import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom'
import Header2 from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import ModalVideo from 'react-modal-video'
import CtaSection from '../../components/CtaSection/CtaSection';
import PolicySection from './Policy';
import offerBanner from '../../images/icons/best_offer.svg.svg';
import PartnerSection from '../../components/PartnerSection';

import Services from '../../api/service';
import './pricing.css'

const PricingPage = (props) => {

    const [isOpen, setOpen] = useState(false)

    const [isActive, setIsActive] = useState(true);
    const [isActiveC, setIsActiveC] = useState(true);

    const handleToggle = () => {
        setIsActive(!isActive);
    };


    const [currency, setCurrency] = useState('GBP');
    const handleTogglePrice = () => {
        setIsActiveC(!isActiveC);
        setCurrency(prev => (prev === "USD" ? "GBP" : "USD"));
    };


    return (
        <Fragment>
            <Header2 />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Pricing Plan'} pageTop={'Our'} />
                <PolicySection />
                <section className="pricing_section section_space pb-0 bg-light">
                    <div className="container">
                        <div className="heading_block text-center">

                            <h2 className="heading_text mb-0">
                                Best Plane for Business
                            </h2>
                        </div>
                        <div className="pricing_toggle_btn text-center">
                            <button type="button" onClick={handleToggle} className={isActive ? 'active' : ''}>
                                <span>Billed Hourly <small>-10%</small></span>
                                <span>Billed Monthly <small>-30%</small></span>
                            </button>
                        </div>
                        <div className="pricing_toggle_btn pricing_toggle_btn_ped text-center">
                            <button type="button" onClick={handleTogglePrice} className={isActiveC ? 'active' : ''}>
                                <span>Pound <small>£</small></span>
                                <span>Dollar <small>$</small></span>
                            </button>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>

                                    <div className="table_head">

                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <div className="starting-from-label">Starting From</div>
                                            {currency === 'USD' ? (
                                                <>
                                                    <span className="pricing_monthly">
                                                        <del>$22</del> $20 <sub>You'll Save <u>$2</u> Hourly</sub>
                                                    </span>
                                                    <span className="pricing_annually">
                                                        <del>$240</del> $216<small>.6</small> <sub>You'll Save <u>$24</u> Monthly</sub>
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="pricing_monthly">
                                                        <del>£18</del> £16.5 <sub>You'll Save <u>£1.5</u> Hourly</sub>
                                                    </span>
                                                    <span className="pricing_annually">
                                                        <del>£180.8</del> £163<small>.2</small> <sub>You'll Save <u>£18</u> Monthly</sub>
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Standard Tier</h3>
                                            <p className="pricing_package_description mb-0">
                                            Essential IT solutions tailored for everyday business needs.
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">

                                        {Services.map(service => (
                                                <li key={service.Id} className={  service.Id === "4" || service.Id === "14" || service.Id === "12" || service.Id === "8" || service.Id === "11" || service.Id === "9" ? "delete" : ""}>
                                                    <span className="icon_list_icon">
                                                        <i className="fa-regular fa-circle-check"></i>
                                                    </span>
                                                    <span className="icon_list_text">
                                                        {service.thumb1}
                                                    </span>
                                                </li>
                                            ))}
                                    </ul>
                                    <Link to="/contact" state={{ message: "Purchase Pro Package: " }} className="btn btn-light">
                                        <span className="btn_label" data-text="Purchase Now">Purchase Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>
                                    <div className="best_plan">
                                        <img src={offerBanner} alt="Best Offer" />
                                    </div>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <div className="starting-from-label">Starting From</div>
                                            {currency === 'USD' ? (
                                                <>
                                                    <span className="pricing_monthly">
                                                        <del>$28</del> $23 <sub>You'll Save <u>$5</u> Hourly</sub>
                                                    </span>
                                                    <span className="pricing_annually">
                                                        <del>$300</del> $240<small></small> <sub>You'll Save <u>$60</u> Monthly</sub>
                                                    </span>
                                                </>
                                            ) : (
                                                <>
                                                    <span className="pricing_monthly">
                                                        <del>£21.84</del> £18 <sub>You'll Save <u>£3.77</u> Hourly</sub>
                                                    </span>
                                                    <span className="pricing_annually">
                                                        <del>£226</del> £180<small>.8</small> <sub>You'll Save <u>£45.2</u> Monthly</sub>
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Pro Tier</h3>
                                            <p className="pricing_package_description mb-0">
                                            Premium solutions built for precision, security, and scale.
                                            </p>
                                        </div>
                                    </div>

                                    <ul className="icon_list unordered_list_block">
                                        {/* Select specific services by their IDs or other criteria */}
                                        {Services.map(service => (
                                            <li key={service.Id} className={service.Id === "0" || service.Id === "0" ? "delete" : ""}>
                                                <span className="icon_list_icon">
                                                    <i className="fa-regular fa-circle-check"></i>
                                                </span>
                                                <span className="icon_list_text">
                                                    {service.thumb1}
                                                </span>
                                            </li>
                                        ))}
                                    </ul>
                                    <Link to="/contact" state={{ message: "Purchase Team Package: " }} className="btn btn-light">
                                        <span className="btn_label" data-text="Purchase Now">Purchase Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="client_logo_section section_space bg-light">
                    <div className="container">
                        <div className="heading_block text-center">

                        </div>
                        <PartnerSection />
                    </div>
                </div>
            </main>
            <CtaSection />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default PricingPage;
